
import React, { useEffect } from 'react';
import { MappedComponentProperties } from '@adobe/aem-react-editable-components';
import { usePushdownContext } from '../../providers/Pushdown/PushdownProvider';

interface NaturalDisasterBulletinPushdownProps extends MappedComponentProperties {
    header?: string;
    description?: string;
    messages?: string[];
    color?: string;
    showPushdown?: boolean;
}

export const NaturalDisasterBulletinPushdownEditConfig = {
    emptyLabel: 'Natural Disaster Bulletin Pushdown',
    isEmpty: () => true,
};

const NaturalDisasterBulletinPushdown = (props: NaturalDisasterBulletinPushdownProps) => {
    const { showPushdown } = usePushdownContext();

    useEffect(() => {
        if (props.showPushdown) {
            showPushdown({
                header: props.header,
                description: props.description,
                message: props.messages,
                color: props.color,
            });
        }
    }, []);

    return <></>;
};

export default NaturalDisasterBulletinPushdown;
